function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types'; // import Swiper from 'react-id-swiper/lib/ReactIdSwiper.full';

import { Swiper, Navigation, Pagination } from 'swiper/js/swiper.esm.js';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import 'swiper/css/swiper.css';
import Modal from 'react-responsive-modal';
import * as StyledComps from '../StyledComps';
import Imagine from '../Imagine';

var MediasSwiper = function MediasSwiper(props) {
  var params = {
    Swiper: Swiper,
    modules: [Pagination, Navigation],
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 0,
    autoHeight: true,
    effect: 'fade' // watchOverflow: true,

  };
  return /*#__PURE__*/React.createElement(ReactIdSwiperCustom, params, props.medias.map(function (media, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "item",
      key: index
    }, /*#__PURE__*/React.createElement(Imagine, {
      src: media.url,
      width: 800
    }));
  }));
};

export var Render = /*#__PURE__*/function (_Component) {
  _inherits(Render, _Component);

  var _super = _createSuper(Render);

  function Render() {
    var _this;

    _classCallCheck(this, Render);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      current: 0
    });

    _defineProperty(_assertThisInitialized(_this), "errorAlert", function () {
      var _this$props = _this.props,
          debug = _this$props.debug,
          region = _this$props.region;

      if (debug) {
        alert("Error: ".concat(JSON.stringify(region.medias)));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateLightbox", function (isOpen) {
      return function () {
        var region = _this.props.region;

        if (isOpen) {
          _this.props.handleViewerEvent('regionClick', {
            region: region
          });
        }

        _this.setState({
          isOpen: isOpen
        });
      };
    });

    return _this;
  }

  _createClass(Render, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          region = _this$props2.region,
          debug = _this$props2.debug,
          pageRef = _this$props2.pageRef,
          medias = _this$props2.medias,
          multiple = _this$props2.multiple;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          current = _this$state.current;

      if (!medias || !medias.length) {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
          onClick: this.errorAlert
        }, debug ? region['@id'] : null));
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
        onClick: this.updateLightbox(true)
      }, debug ? region['@id'] : null), pageRef && pageRef.current !== null ? /*#__PURE__*/React.createElement(Modal, {
        open: isOpen,
        onClose: this.updateLightbox(false),
        center: true,
        closeOnEsc: !!region.settings.backdropExit,
        closeOnOverlayClick: !!region.settings.backdropExit,
        classNames: StyledComps.classes.slideshow,
        styles: {
          overlay: {
            backgroundColor: region.settings.backdropColor ? region.settings.backdropColor : 'rgba(0,0,0,.5)',
            position: 'absolute'
          }
        },
        container: pageRef.current
      }, /*#__PURE__*/React.createElement(StyledComps.PageLightboxSlideshowWrapper, {
        multiple: multiple
      }, /*#__PURE__*/React.createElement(MediasSwiper, {
        medias: medias
      }))) : null);
    }
  }]);

  return Render;
}(Component);
Render.propTypes = {
  region: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  handleViewerEvent: PropTypes.func.isRequired,
  pageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  debug: PropTypes.bool
};
Render.defaultProps = {
  region: null,
  onPageChange: null,
  debug: false
};
export default Render;